import React from 'react'
import Lightbox from 'yet-another-react-lightbox'
import 'yet-another-react-lightbox/styles.css'
import Fullscreen from 'yet-another-react-lightbox/plugins/fullscreen'
import Slideshow from 'yet-another-react-lightbox/plugins/slideshow'
import Thumbnails from 'yet-another-react-lightbox/plugins/thumbnails'
import Zoom from 'yet-another-react-lightbox/plugins/zoom'
import Captions from 'yet-another-react-lightbox/plugins/captions'
import 'yet-another-react-lightbox/plugins/thumbnails.css'
import 'yet-another-react-lightbox/plugins/captions.css'
import { appendImageURL } from '../../../helper/function'

const ViewDocument = ({ showDocuments, setShowDocuments, images,index }) => {
  return (
    <Lightbox
      open={showDocuments}
      close={() => setShowDocuments(false)}
      slides={images?.map((item) => {
        return {
          src: appendImageURL(item)
        }
      })}
      index={index} 
      plugins={[Captions, Fullscreen, Slideshow, Thumbnails, Zoom]}
    />
  )
}

export default ViewDocument
